import {
  LuBarChart2,
  LuBookmark,
  LuBox,
  LuCpu,
  LuFile,
  LuGift,
  LuGrid,
  LuHotel,
  LuInfo,
  LuLayoutGrid,
  LuListOrdered,
  LuLock,
  LuMap,
  LuSettings2,
  LuSoup,
  LuUserCog,
  LuUsers,
  LuWallet,
  LuStretchHorizontal,
  LuConciergeBell,
  LuBean,
} from "react-icons/lu";

const clientMenuItems = [
  {
    key: "home-page",
    label: "Home",
    url: "/home",
    isTitle: true,
  },
  {
    key: "dish",
    label: "Dishes",
    isTitle: true,
    children: [
      {
        key: "dish-grid",
        label: "Dishes Grid",
        url: "/dishes",
        parentKey: "dish",
      },
      {
        key: "dish-list",
        label: "Dishes List",
        url: "/dishes-list",
        parentKey: "dish",
      },
      {
        key: "dish-details",
        label: "Dish Details",
        url: "/dishes/1001",
        parentKey: "dish",
      },
    ],
  },
  {
    key: "user-pages",
    label: "Pages",
    isTitle: true,
    children: [
      {
        key: "user-pages-account-cart",
        label: "Cart",
        url: "/cart",
        parentKey: "user-pages",
      },
      {
        key: "user-pages-account-wishlist",
        label: "Wishlist",
        url: "/wishlist",
        parentKey: "user-pages",
      },
      {
        key: "user-pages-checkout",
        label: "Checkout",
        url: "/checkout",
        parentKey: "user-pages",
      },
      {
        key: "user-pages-faqs",
        label: "FAQ",
        url: "/faqs",
        parentKey: "user-pages",
      },
      {
        key: "user-pages-contact-us",
        label: "Contact Us",
        url: "/contact-us",
        parentKey: "user-pages",
      },
      {
        key: "user-pages-not-found",
        label: "Error 404",
        url: "/not-found",
        parentKey: "user-pages",
      },
      {
        key: "auth-login",
        label: "Login",
        url: "/auth/login",
        parentKey: "user-pages",
      },
      {
        key: "auth-register",
        label: "Register",
        url: "/auth/register",
        parentKey: "user-pages",
      },
      {
        key: "auth-forgot-password",
        label: "Forgot Password",
        url: "/auth/forgot-password",
        parentKey: "user-pages",
      },
      {
        key: "auth-reset-password",
        label: "Reset Password",
        url: "/auth/reset-password",
        parentKey: "user-pages",
      },
      {
        key: "auth-logout",
        label: "Logout",
        url: "/auth/logout",
        parentKey: "user-pages",
      },
    ],
  },
  {
    key: "admin-dashboard",
    label: "Admin",
    url: "/admin/dashboard",
    isTitle: true,
  },
];

const megaMenuItem = {
  key: "mega-menu",
  label: "Mega Menu",
  isTitle: true,
  isMega: true,
  children: [
    {
      key: "mega-menu-1",
      label: "Mega Menu",
      url: "/home",
      parentKey: "mega-menu",
    },
  ],
};

const addMegaMenu = () => {
  const menuItems = [...clientMenuItems];
  menuItems.splice(2, 0, megaMenuItem);
  return menuItems;
};

export const HORIZONTAL_MENU_ITEMS = addMegaMenu();

export const CLIENT_VERTICAL_MENU_ITEMS = clientMenuItems;

export const ADMIN_VERTICAL_MENU_ITEMS = [
  {
    key: "dashboard-page",
    label: "Dashboard",
    icon: LuLayoutGrid,
    url: "/admin/dashboard",
    isTitle: true,
  },
  {
    key: "starter-page",
    label: "Starter Page",
    icon: LuGrid,
    url: "/admin/starter-page",
    isTitle: true,
  },
  {
    key: "categories",
    label: "Categories",
    icon: LuStretchHorizontal,
    isTitle: true,
    children: [
      {
        key: "sellers-list",
        label: "Categories List",
        url: "/admin/categories",
        parentKey: "categories",
      },
      {
        key: "category-sizes",
        label: "Category Sizes",
        url: "/admin/category-sizes",
        parentKey: "categories",
      },
    ],
  },
  {
    key: "ingrediens-page",
    label: "Ingrediens",
    icon: LuBean,
    url: "/admin/ingrediens",
    isTitle: true,
  },
  {
    key: "product-page",
    label: "Products",
    icon: LuConciergeBell,
    url: "/admin/products",
    isTitle: true,
  },
];

export const FOOTER_LINKS = {
  About: [
    { name: "About Us" },
    { name: "Features" },
    { name: "News" },
    { name: "Careers" },
    { name: "Services" },
  ],
  Company: [
    { name: "Our Team" },
    { name: "Partner with Us" },
    { name: "FAQs" },
    { name: "Blog" },
  ],
  Support: [
    { name: "About" },
    { name: "Support Center" },
    { name: "Feedback" },
    { name: "Contact Us", link: "/contact-us" },
    { name: "Accessibility" },
  ],
};
